import React, { useState } from 'react';
import { Box, IconButton, Typography } from '@material-ui/core';
import { Drawer } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { filterDrawerIsOpenSelector } from '../../../store/modules/ui/selectors';
import { uiSliceActions } from '../../../store/modules/ui/reducer';
import { distanceRadiusInKmSelector, selectedPartnerCategoriesSelector } from '../../../store/modules/filters/selectors';
import IconRenderer from 'global/react-mui/atoms/IconRenderer';
import { filtersSliceActions } from '../../../store/modules/filters/reducer';
import Slider from 'global/react-mui/atoms/Slider';
import CategoryToggleFilter from '../CategoryToggleFilter';
import Button from 'global/react-mui/atoms/Button';
import { useStyles } from './styles';
import { translationsSelector } from '../../../store/modules/translations/selectors';

type MobileFiltersDrawerProps = {
	classes?: any;
};

const MobileFiltersDrawer: React.FC<MobileFiltersDrawerProps> = ({ classes }) => {
	const dispatch = useDispatch();

	const internalClasses = useStyles();
	const isFilterDrawerOpen = useSelector(filterDrawerIsOpenSelector);
	const closeFilterDrawer = () => dispatch(uiSliceActions.setIsFilterDrawerOpen({ isOpen: false }));
	const distanceRadiusInKm = useSelector(distanceRadiusInKmSelector);
	const selectedPartnerCategories = useSelector(selectedPartnerCategoriesSelector);
	const { searchFilterTitle, searchFilterSubmitButton, searchFilterRadiusLabel, searchFilterCategoriesLabel } = useSelector(translationsSelector);

	const [tempFilters, setTempFilters] = useState({
		distanceRadiusInKm,
		selectedPartnerCategories,
	});

	const setTempDistanceRadiusInKm = (_, newDistanceRadiusInKm) => setTempFilters((temp) => ({ ...temp, distanceRadiusInKm: newDistanceRadiusInKm }));

	const setTempSelectedPartnerCategories = (newPartnerCategory) => {
		const isCurrentlySelected = tempFilters.selectedPartnerCategories.includes(newPartnerCategory);
		if (isCurrentlySelected) {
			setTempFilters((temp) => ({
				...temp,
				selectedPartnerCategories: temp.selectedPartnerCategories.filter((item) => item !== newPartnerCategory),
			}));
		} else {
			setTempFilters((temp) => ({ ...temp, selectedPartnerCategories: [...temp.selectedPartnerCategories, newPartnerCategory] }));
		}
	};

	const onSubmitFilters = () => {
		dispatch(filtersSliceActions.setFilters(tempFilters));
		closeFilterDrawer();
	};

	const onCloseWithoutSaving = () => {
		setTempFilters({
			distanceRadiusInKm,
			selectedPartnerCategories,
		});
		closeFilterDrawer();
	};

	return (
		<Drawer
			className={internalClasses.root}
			variant="temporary"
			anchor="bottom"
			open={isFilterDrawerOpen}
			onClose={onCloseWithoutSaving}
			classes={{
				paper: internalClasses.paper,
			}}>
			<Box height="90vh" width="100%" display="flex" flexDirection="column">
				<IconButton className={internalClasses.closeIcon} onClick={onCloseWithoutSaving}>
					<IconRenderer icon="close" />
				</IconButton>
				<Box display="flex" width="100%" alignItems="center" justifyContent="center">
					<Typography className={internalClasses.title} color="textSecondary" component="h4" variant="h4">
						{searchFilterTitle}
					</Typography>
				</Box>
				<Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
					<Box display="flex" flexDirection="column" mt={5}>
						<Typography className={internalClasses.label} color="textSecondary" component="label">
							{`${searchFilterRadiusLabel}: ${tempFilters.distanceRadiusInKm}km`}
						</Typography>
						<Slider
							handleOnChange={setTempDistanceRadiusInKm}
							id="range-slider"
							defaultValue={25}
							formControlProps={{ minHeight: 42, style: { justifyContent: 'center', width: 'auto' } }}
						/>
						<Box>
							<Typography className={internalClasses.label} color="textSecondary" component="label">
								{`${searchFilterCategoriesLabel}`}
							</Typography>
							<CategoryToggleFilter selected={tempFilters.selectedPartnerCategories} handleOnChange={setTempSelectedPartnerCategories} />
						</Box>
					</Box>
					<Button mx={2} mb={5} color="primary" onClick={onSubmitFilters}>
						{searchFilterSubmitButton}
					</Button>
				</Box>
			</Box>
		</Drawer>
	);
};

export default MobileFiltersDrawer;
